import React from "react";
import NavBar1 from '../../components/Navbar1/NavBar1';
import Footer from '../../components/Footer/Footer'; 
import SideBar from '../../components/SideBar/SideBar';
import SpecfifcWorkoutPlan from "../../components/SpecificWorkout/SpecificWorkout"
const SpecfifcWorkout = props=>{
    return(
        <>
        <NavBar1 />
       <SideBar>
           <Footer>

                <SpecfifcWorkoutPlan/>

           </Footer>

       </SideBar>
            
        
       </>
    )
}

export default SpecfifcWorkout;